/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const ImportStrategy = {
  SKIP: 'SKIP',
  OVERWRITE: 'OVERWRITE',
  SAVE_AS_NEW: 'SAVE_AS_NEW',
};
